<template>
  <div class="o-couponSection" v-if="!isFetchingCart">
    <ToggleText
      class="o-couponSection__toggleCoupon"
      :faIconClass="showCouponCode ? 'fas fa-minus' : 'fas fa-plus'"
      text="Coupon code"
      v-on:toggleEditable="toggleCouponCode"/>
    <div v-show="showCouponCode" v-if="couponCode" class="o-couponSection--coupon">
      <LabelTag :labelTitle="couponCode" />
      <ToggleText
        faIconClass="fas fa-times"
        text="Remove"
        class="o-couponSection--coupon__toggleRemove"
        v-on:toggleEditable="removeCoupon"
      />
    </div>
    <div v-show="showCouponCode" v-else class="o-couponSection--apply">
      <InputText
        name="coupon-code"
        :maxlength="50"
        :errorMessage="errorCoupon !== '' ? errorCoupon: ''"
        v-model="couponCodeToAdd" 
      />
      <button
        class="o-couponSection--apply__Button a-Button--Small a-Button--LightBlue"
        v-on:click="addCoupon"
      >Apply
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InputText from '../atoms/InputText.vue'
import ToggleText from '../atoms/ToggleText.vue'
import LabelTag from '../atoms/LabelTag.vue'

export default {
  computed: mapState({
    couponCode: state => state.cart.couponCode,
    errorMessage: state => state.globalstate.errorMessage,
    isFetchingCart: state => state.cart.fetchingCart,
    hasCouponCode () {
      if (this.couponCode) this.showCouponCode = true
    }
  }),
  provide () {
    return { parentValidator: this.$validator }
  },
  watch: {
    couponCode () {
      this.hasCouponCode
    }
  },
  components: { InputText, ToggleText, LabelTag },
  methods: {
    toggleCouponCode () {
      this.showCouponCode = !this.showCouponCode
    },
    async addCoupon () {
      const response = await this.$store.dispatch('cart/addCoupon', {
        couponCode: this.couponCodeToAdd
      })
      if (response !== undefined && response.error !== '') {
        this.errorCoupon = 'Invalid code'
      } else {
        this.errorCoupon = ''
      }
    },
    removeCoupon () {
      this.$store.dispatch('cart/removeCoupon', {})
      this.couponCodeToAdd = ''
    }
  },
  data () {
    return {
      showCouponCode: false,
      couponCodeToAdd: '',
      errorCoupon: ''
    }
  },
  mounted () {
    this.hasCouponCode
  }
}
</script>



// WEBPACK FOOTER //
// CartCoupon.vue?1fb5d146